import { useQuery } from '@tanstack/react-query';
import get from 'lodash/get';
import sortBy from 'lodash/sortBy';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import { getHomeTopCategories } from '../../services';

export function useGetHomeTopCategories({ params, options = {} } = {}) {
  return useQuery(
    createQueryKey(QUERY_KEYS.useGetHomeTopCategoriesKey, params),
    () => getHomeTopCategories(params),
    {
      select: data => {
        let docs = get(data.docs[0], 'value.data');
        return sortBy(docs, ['order', 'name']);
      },
      ...options
    }
  );
}
